/* eslint-disable import/prefer-default-export */
export const signUpFormsFields = [
    { name: 'Prefix', code: 'prefix', visibility: [true, true, true] },
    { name: 'First Name', code: 'firstName', visibility: [true, true, true] },
    { name: 'Middle Name', code: 'middleName', visibility: [true, true, true] },
    { name: 'Last Name', code: 'lastName', visibility: [true, true, true] },
    { name: 'Suffix', code: 'suffix', visibility: [true, true, true] },
    { name: 'Email', code: 'emailAddress', visibility: [true, true, true] },
    { name: 'Gender', code: 'gender', visibility: [true, true, false] },
    { name: 'Phone Number', code: 'phoneNumber', visibility: [true, true, true] },
    { name: 'Mobile Phone Number', code: 'mobilePhoneNumber', visibility: [true, true, true] },
    { name: 'Birth Date', code: 'dateOfBirth', visibility: [true, true, false] },
    { name: 'Comments', code: 'comments', visibility: [false, true, false] },
    {
        name: 'Address Name',
        code: 'addressTypeList',
        visibility: [true, true, true]
    },
    { name: 'Address 1', code: 'address1', visibility: [true, true, true] },
    { name: 'Address 2', code: 'address2', visibility: [true, true, true] },
    { name: 'City', code: 'city', visibility: [true, true, true] },
    { name: 'State/Province', code: 'stateProvince', visibility: [true, true, true] },
    { name: 'Country', code: 'country', visibility: [true, true, true] },
    { name: 'Zip/Postal Code', code: 'zipPostalCode', visibility: [true, true, true] },
    { name: 'CVV/CVC Code', code: 'cvvCode', visibility: [false, false, true] },
    { name: 'Marketing Opt In', code: 'emailOptIn', visibility: [true, true, true] },
    {
        name: 'Loyalty Section - User can add loyalty programs to their profile',
        code: 'loyaltyProgram',
        visibility: [false, true, true]
    },
    {
        name: 'Saved Credit Cards - User can add credit cards to their profile',
        code: 'paymentInfo',
        visibility: [false, true, false]
    },
    { name: 'Booking Options', code: 'policyAcknowledgement', visibility: [false, false, true] }
];



// WEBPACK FOOTER //
// ./src/constants/SignUpFormsFields.js